module.exports = __webpack_public_path__ + "img/TN.f07a886c.svg";